<template>
  <el-dialog
    class="default-dialog"
    title="选择模板"
    :visible.sync="templateModal"
    width="1100px"
    append-to-body
    :close-on-click-modal="false"
  >
  	<div v-loading="temLoading" :element-loading-text="temLoadingText" class="public-templates">
  		<el-row :gutter="15">
  			<el-col :span="6">
  				<div class="card-item first">
  					<el-card @click.native="openSaveTemplate">
  						+
  					</el-card>
  					<span class="card-text">保存当前日记账为模板</span>
  				</div>
  			</el-col>
  			<el-col :span="6" v-for="(item,index) in list" :key="index">
  				<div class="card-item">
  					<el-card>
              <div class="item_tips">
                <div class="item_tips_i">
                  日期：{{item.date}}
                </div>
                <div class="item_tips_i" v-if="item.summary[0]">
                  摘要：{{item.summary[0].value}}
                </div>
                <div class="item_tips_i" v-if="item.summary[1]">
                  {{item.directionType==1?"收入":"支出"}}：{{currencys(item.summary[1].value)}}
                </div>
              </div>
  						<div class="maskModal"></div>
  						<div class="maskModal1">
  							<el-button size="mini" type="primary" @click="$emit('useTemplate',item)">使用</el-button>
  							<el-button size="mini" type="danger"  @click="$emit('delTemplate',item)">删除</el-button>
  						</div>
  					</el-card>
  					<span class="card-text">{{item.templateName}}</span>

  				</div>
  			</el-col>
  		</el-row>
  	</div>

    <!-- 添加 -->
    <el-dialog
      class="default-dialog"
      title="保存模板为"
       append-to-body
      :visible.sync="templateSave"
      width="400px"
      :close-on-click-modal="false"
    >
    	<div v-loading="saveTemLoading" element-loading-text="保存模板中">
    		<span>将当前正在使用的日记账保存到“日记账模板”中，您可以将随时调用这些模板。</span>
    		<el-form style="margin-top: 10px;" v-if="templateSave"
    			ref="templateForm" :model="templateForm" :rules="temFormRule"
    		>
    			<el-form-item prop=" templateName">
    				<el-input v-model="templateForm.templateName" size="small" placeholder="模板名称"></el-input>
    			</el-form-item>
    			<el-form-item prop="isSaveMoney">
    				<el-checkbox v-model="templateForm.savingAmount">同时保存金额</el-checkbox>
    			</el-form-item>
    		</el-form>
    	</div>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="templateSave = false">取消</el-button>
    		<el-button size="small" class='minButton' @click="saveTemplate">确定</el-button>
    	</div>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import {currencys} from '@/assets/utils/currencyFormat'
  export default {
    props:{
      isNotSave:[Boolean],
      list:[Array],
      getTemplate:[Function]
    },
    data() {
      return {
        currencys,
        templateModal:false,
        temLoading:false,
        templateSave:false,  // 二级弹框
        temLoadingText:"",
        subjectNameList:[],
        saveTemLoading:false,
        temFormRule:{
        	templateName:[{required:true,message:'模板名称必填！'}]
        },
        templateForm:{
          templateName:"",
          savingAmount:""
        }
      }
    },
    watch:{
        templateModal(val) {
		   if(val) {
				this.getTemplate();
                this.$emit("closeKeyWatch")
            }else {
                this.$emit("openKeyWatch")
        }
      }
    },
    methods:{
      // 保存模板
      saveTemplate() {
        this.templateSave = false;
        this.$emit('saveTemplate',this.templateForm);
      },
      // 打开保存命名界面
      openSaveTemplate() {
        // if(this.isNotSave) { return this.$message.warning("请保存当前日记账后再保存模板！") }
        this.templateForm.savingAmount = false;
        this.templateForm.templateName = '';
        this.templateSave = true;
      },
    }
  }
</script>

<style lang="less">
  .public-templates{
  	height: 450px;
  	overflow-x: hidden;
  	overflow-y: auto;
  	.card-item{
      .item_tips {
        &_i {
          color: #666;
          margin-bottom: 5px;
        }
      }
  		.el-card{
  			height: 150px;cursor: pointer;position: relative;
  			.el-card__body{
  				height: 110px;
  			}
  			.maskModal{
  				display: none;
  				position: absolute;
  				top:0;right: 0;left: 0;
  				width: 100%;height: 100%;
  				background-color: #333;
  				opacity: 0.4;
  				z-index: 0;
  			}
  			.maskModal1{
  				display: none;
  				position: absolute;
  				top:0;right: 0;left: 0;
  				height: 100%;
  				z-index: 1;
  				align-items: center;
  				justify-content:center;
  			};
  			&:hover{
  				.maskModal1{
  					display: flex;
  				}
  				.maskModal{
  					display: block;
  				}
  			}
  		}
  		.card-text{font-size: 14px;line-height: 30px;display: block;text-align: center}
  		&.first{
  			.el-card{
  				text-align: center;
  				font-size: 60px;
  				line-height:90px;
  				background-color: #f2f2f2;
  				color: #fff
  			}
  		}
  	}
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/c-template.vue